import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import {
  VueAxios
} from './axios'
import notification from 'ant-design-vue/es/notification'
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'

var apiBaseURL = process.env.VUE_APP_API_SERVER_BASE_URL || ''
if (apiBaseURL.endsWith('/')) {
  apiBaseURL = apiBaseURL.substring(0, apiBaseURL.length - 1)
}

const requestRootPath = '/'
// if (process.env.VUE_APP_BUILD_TARGET === 'test' || process.env.VUE_APP_BUILD_TARGET === 'prod') {
//   requestRootPath = '/mgr/'
// } else {
//   requestRootPath =  '/'
// }
// 创建 axios 实例
const service = axios.create({
  baseURL: apiBaseURL + requestRootPath  + 'api/', // api base_url
  timeout: 60000, // 请求超时时间
  paramsSerializer: params => {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  }
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    // 用户未登录 Unauthorized
    if (error.response.status === 401) {
      notification.error({
        message: '401',
        description: 'Unauthorized.'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
    // 语义有误 或 请求参数有误
    if (error.response.status === 400) {
      notification.error({
        message: '400 Bad Request',
        description: data ? data.errorMessage : 'Unknowned.'
      })
    }
    // 用户权限不足 Forbidden
    if (error.response.status === 403) {
      notification.error({
        message: '403 Forbidden',
        description: data ? data.errorMessage : 'Unknowned.'
      })
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  const sabreAuthToken = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  if (sabreAuthToken) {
    config.headers['Authorization'] = 'Bearer ' + sabreAuthToken
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
